/**
 * dockIcons.tsx — GENERATED by scripts/generate-dock-icons.js. Do not edit by
 * hand; edit the SVGs in src/assets/dock-icons/ and re-run the script.
 *
 * Module tiles are complete app icons: each draws its OWN rounded face,
 * border and glyph, so the dock button behind them must stay transparent
 * (no background, border or gloss of its own — see .pq-dock-app in
 * index.css). Gradient ids are namespaced per icon because all of these
 * live inline in one document.
 *
 * Theme: each tile carries a light face (.pq-tile-l) and a dark face
 * (.pq-tile-d); index.css displays one per data-theme, and themes the
 * border/separator strokes via --tile-stroke / --tile-sep on the button.
 *
 * Utility glyphs are ghost outlines on stroke="currentColor" — they take
 * the button's text colour and carry no face of their own.
 */
import React from 'react';

const TileAnalytics = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="analytics_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="analytics_g-teal" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#5FE3D2" />
      <stop offset="1" stopColor="#1FBCA8" />
    </linearGradient>
    <linearGradient id="analytics_g-blue" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#8CC2F8" />
      <stop offset="1" stopColor="#468FDA" />
    </linearGradient>
    <linearGradient id="analytics_g-amber" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#FCD466" />
      <stop offset="1" stopColor="#EFA70F" />
    </linearGradient>
    <linearGradient id="analytics_g-sky" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#78D4FB" />
      <stop offset="1" stopColor="#1BA5E6" />
    </linearGradient>
    <linearGradient id="analytics_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#analytics_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#analytics_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <rect x="5" y="26" width="10" height="16" rx="3.5" fill="url(#analytics_g-sky)" />
  <rect x="19" y="18" width="10" height="24" rx="3.5" fill="url(#analytics_g-blue)" />
  <rect x="33" y="10" width="10" height="32" rx="3.5" fill="url(#analytics_g-teal)" />
  <path d="M10 21L24 13l14-5.5" fill="none" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="6.5" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M10 21L24 13l14-5.5" fill="none" stroke="url(#analytics_g-amber)" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
</svg>
);

const TileCommunication = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="communication_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="communication_g-teal" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#5FE3D2" />
      <stop offset="1" stopColor="#1FBCA8" />
    </linearGradient>
    <linearGradient id="communication_g-sky" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#78D4FB" />
      <stop offset="1" stopColor="#1BA5E6" />
    </linearGradient>
    <linearGradient id="communication_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#communication_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#communication_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <rect x="5" y="8" width="38" height="28" rx="6" fill="url(#communication_g-sky)" />
  <path d="M9 12l15 11.5L39 12" fill="none" stroke="#FFFFFF" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M26 23h11a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4h-5l-5 4.5V37h-1a4 4 0 0 1-4-4v-6a4 4 0 0 1 4-4z" fill="url(#communication_g-teal)" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="2.2" />
  <circle cx="28.5" cy="30" r="1.7" fill="#FFFFFF" />
  <circle cx="32.5" cy="30" r="1.7" fill="#FFFFFF" />
  <circle cx="36.5" cy="30" r="1.7" fill="#FFFFFF" />
</svg>
);

const TileCrm = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="crm_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="crm_g-teal" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#5FE3D2" />
      <stop offset="1" stopColor="#1FBCA8" />
    </linearGradient>
    <linearGradient id="crm_g-blue" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#8CC2F8" />
      <stop offset="1" stopColor="#468FDA" />
    </linearGradient>
    <linearGradient id="crm_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#crm_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#crm_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <rect x="5" y="7" width="38" height="34" rx="6" fill="url(#crm_g-blue)" />
  <circle cx="18" cy="20" r="5" fill="#FFFFFF" />
  <path d="M10 33a8 8 0 0 1 16 0z" fill="#FFFFFF" />
  <rect x="30" y="17.5" width="9" height="3" rx="1.5" fill="#FFFFFF" opacity="0.9" />
  <rect x="30" y="24.5" width="6" height="3" rx="1.5" fill="#FFFFFF" opacity="0.62" />
  <circle cx="35.5" cy="34" r="7.2" fill="url(#crm_g-teal)" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="2.4" />
  <path d="M32.5 34.2l2.2 2.2 4-4.4" fill="none" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
</svg>
);

const TileDashboard = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="dashboard_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="dashboard_g-teal" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#5FE3D2" />
      <stop offset="1" stopColor="#1FBCA8" />
    </linearGradient>
    <linearGradient id="dashboard_g-blue" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#8CC2F8" />
      <stop offset="1" stopColor="#468FDA" />
    </linearGradient>
    <linearGradient id="dashboard_g-sky" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#78D4FB" />
      <stop offset="1" stopColor="#1BA5E6" />
    </linearGradient>
    <linearGradient id="dashboard_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#dashboard_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#dashboard_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <rect x="5" y="5" width="21" height="21" rx="4.2" fill="url(#dashboard_g-teal)" />
  <rect x="30" y="5" width="13" height="21" rx="4.2" fill="url(#dashboard_g-blue)" />
  <rect x="5" y="30" width="21" height="13" rx="4.2" fill="url(#dashboard_g-sky)" />
  <rect x="30" y="30" width="13" height="13" rx="4.2" fill="url(#dashboard_g-blue)" />
</svg>
);

const TileFinance = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="finance_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="finance_g-amber" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#FCD466" />
      <stop offset="1" stopColor="#EFA70F" />
    </linearGradient>
    <linearGradient id="finance_g-green" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#6DE4B5" />
      <stop offset="1" stopColor="#1FB983" />
    </linearGradient>
    <linearGradient id="finance_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#finance_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#finance_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <circle cx="21" cy="26" r="17" fill="url(#finance_g-amber)" />
  <circle cx="21" cy="26" r="12.5" fill="none" stroke="#FFFFFF" strokeWidth="1.6" opacity="0.45" />
  <path d="M21 15v22" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
  <path d="M27 21.5a4.5 4.5 0 0 0-4.5-4.5h-2.6a4.5 4.5 0 0 0 0 9h2.6a4.5 4.5 0 0 1 0 9H19a4.5 4.5 0 0 1-4.5-4.5" fill="none" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
  <circle cx="35" cy="13" r="7.5" fill="url(#finance_g-green)" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="2.4" />
  <path d="M35 16.9V9.6M31.8 12.8L35 9.4l3.2 3.4" fill="none" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
</svg>
);

const TileHr = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="hr_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="hr_g-teal" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#5FE3D2" />
      <stop offset="1" stopColor="#1FBCA8" />
    </linearGradient>
    <linearGradient id="hr_g-blue" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#8CC2F8" />
      <stop offset="1" stopColor="#468FDA" />
    </linearGradient>
    <linearGradient id="hr_g-sky" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#78D4FB" />
      <stop offset="1" stopColor="#1BA5E6" />
    </linearGradient>
    <linearGradient id="hr_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#hr_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#hr_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <circle cx="24" cy="11" r="5.5" fill="url(#hr_g-teal)" />
  <rect x="15" y="20" width="18" height="9" rx="4.5" fill="url(#hr_g-teal)" />
  <circle cx="14.5" cy="22.5" r="6.5" fill="url(#hr_g-blue)" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="2.2" />
  <rect x="5.1" y="32" width="18.8" height="10" rx="5" fill="url(#hr_g-blue)" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="2.2" />
  <circle cx="33.5" cy="22.5" r="6.5" fill="url(#hr_g-sky)" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="2.2" />
  <rect x="24.1" y="32" width="18.8" height="10" rx="5" fill="url(#hr_g-sky)" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="2.2" />
</svg>
);

const TileMarketing = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="marketing_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="marketing_g-teal" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#5FE3D2" />
      <stop offset="1" stopColor="#1FBCA8" />
    </linearGradient>
    <linearGradient id="marketing_g-amber" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#FCD466" />
      <stop offset="1" stopColor="#EFA70F" />
    </linearGradient>
    <linearGradient id="marketing_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#marketing_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#marketing_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <rect x="5" y="18" width="8" height="12" rx="4" fill="url(#marketing_g-amber)" />
  <path d="M12 19L31 8v32L12 29z" fill="url(#marketing_g-amber)" stroke="url(#marketing_g-amber)" strokeWidth="4" strokeLinejoin="round" />
  <path d="M35.5 18a10.5 10.5 0 0 1 0 12" fill="none" stroke="url(#marketing_g-teal)" strokeWidth="3.4" strokeLinecap="round" />
  <path d="M40 13.5a17.5 17.5 0 0 1 0 21" fill="none" stroke="url(#marketing_g-teal)" strokeWidth="3.4" strokeLinecap="round" />
</svg>
);

const TileOwner = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="owner_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="owner_g-amber" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#FCD466" />
      <stop offset="1" stopColor="#EFA70F" />
    </linearGradient>
    <linearGradient id="owner_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#owner_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#owner_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <path d="M24 5l16.5 5.4v12.8C40.5 32.5 33.5 39.8 24 43.5 14.5 39.8 7.5 32.5 7.5 23.2V10.4z" fill="url(#owner_g-amber)" />
  <path d="M24 10.4v28.5c6.8-3.2 11.6-8.9 11.6-16.2v-9z" fill="#FFFFFF" opacity="0.14" />
  <path d="M17.8 24l4.5 4.5 9.2-9.8" fill="none" stroke="#FFFFFF" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" />
</svg>
);

const TilePerformance = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="performance_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="performance_g-sky" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#78D4FB" />
      <stop offset="1" stopColor="#1BA5E6" />
    </linearGradient>
    <linearGradient id="performance_g-teal" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#5FE3D2" />
      <stop offset="1" stopColor="#1FBCA8" />
    </linearGradient>
    <linearGradient id="performance_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#performance_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#performance_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <path d="M7 36a17 17 0 1 1 34 0z" fill="url(#performance_g-sky)" />
  <path d="M24 19v17h17a17 17 0 0 0-17-17z" fill="#FFFFFF" opacity="0.14" />
  <path d="M24 30.5l8.2-8.8" fill="none" stroke="#FFFFFF" strokeWidth="3.6" strokeLinecap="round" />
  <circle cx="24" cy="31" r="4.6" fill="url(#performance_g-teal)" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="2.4" />
</svg>
);

const TileProcurement = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="procurement_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="procurement_g-blue" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#8CC2F8" />
      <stop offset="1" stopColor="#468FDA" />
    </linearGradient>
    <linearGradient id="procurement_g-green" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#6DE4B5" />
      <stop offset="1" stopColor="#1FB983" />
    </linearGradient>
    <linearGradient id="procurement_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#procurement_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#procurement_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <path d="M6 8h4.6a3 3 0 0 1 2.9 2.3L14.6 14" fill="none" stroke="url(#procurement_g-blue)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M11 16h32l-4.4 16.4a4.5 4.5 0 0 1-4.3 3.3H19.7a4.5 4.5 0 0 1-4.3-3.3z" fill="url(#procurement_g-blue)" />
  <path d="M22 21.5l1.4 9M31 21.5l-1.4 9" stroke="#FFFFFF" strokeWidth="2.6" strokeLinecap="round" opacity="0.85" />
  <circle cx="19.5" cy="40" r="3.5" fill="url(#procurement_g-blue)" />
  <circle cx="34" cy="40" r="3.5" fill="url(#procurement_g-blue)" />
  <circle cx="35" cy="12" r="7.5" fill="url(#procurement_g-green)" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="2.4" />
  <path d="M31.8 12.2l2.3 2.3 4.2-4.6" fill="none" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
);

const TileSettings = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="settings_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="settings_g-teal" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#5FE3D2" />
      <stop offset="1" stopColor="#1FBCA8" />
    </linearGradient>
    <linearGradient id="settings_g-sky" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#78D4FB" />
      <stop offset="1" stopColor="#1BA5E6" />
    </linearGradient>
    <linearGradient id="settings_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#settings_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#settings_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <rect x="20.5" y="4.5" width="7" height="10.5" rx="2.8" fill="url(#settings_g-teal)" />
  <rect x="20.5" y="4.5" width="7" height="10.5" rx="2.8" fill="url(#settings_g-teal)" transform="rotate(45 24 24)" />
  <rect x="20.5" y="4.5" width="7" height="10.5" rx="2.8" fill="url(#settings_g-teal)" transform="rotate(90 24 24)" />
  <rect x="20.5" y="4.5" width="7" height="10.5" rx="2.8" fill="url(#settings_g-teal)" transform="rotate(135 24 24)" />
  <rect x="20.5" y="4.5" width="7" height="10.5" rx="2.8" fill="url(#settings_g-teal)" transform="rotate(180 24 24)" />
  <rect x="20.5" y="4.5" width="7" height="10.5" rx="2.8" fill="url(#settings_g-teal)" transform="rotate(225 24 24)" />
  <rect x="20.5" y="4.5" width="7" height="10.5" rx="2.8" fill="url(#settings_g-teal)" transform="rotate(270 24 24)" />
  <rect x="20.5" y="4.5" width="7" height="10.5" rx="2.8" fill="url(#settings_g-teal)" transform="rotate(315 24 24)" />
  <circle cx="24" cy="24" r="15" fill="url(#settings_g-teal)" />
  <circle cx="24" cy="24" r="8.4" fill="url(#settings_g-sky)" stroke="var(--tile-sep, #F2F5F9)" strokeWidth="3" />
</svg>
);

const TileSupport = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="support_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="support_g-teal" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#5FE3D2" />
      <stop offset="1" stopColor="#1FBCA8" />
    </linearGradient>
    <linearGradient id="support_g-sky" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#78D4FB" />
      <stop offset="1" stopColor="#1BA5E6" />
    </linearGradient>
    <linearGradient id="support_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#support_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#support_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <path d="M9.5 25v-4a14.5 14.5 0 0 1 29 0v4" fill="none" stroke="url(#support_g-teal)" strokeWidth="4.6" strokeLinecap="round" />
  <rect x="4" y="20" width="9.5" height="15" rx="4.75" fill="url(#support_g-teal)" />
  <rect x="34.5" y="20" width="9.5" height="15" rx="4.75" fill="url(#support_g-teal)" />
  <path d="M39.25 35v0.5a3.5 3.5 0 0 1-3.5 3.5H29" fill="none" stroke="url(#support_g-sky)" strokeWidth="3.2" strokeLinecap="round" />
  <rect x="19" y="37" width="10" height="7" rx="3.5" fill="url(#support_g-sky)" />
</svg>
);

const TileTasks = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <defs>
    <linearGradient id="tasks_tile" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" />
      <stop offset="1" stopColor="#E7EBF1" />
    </linearGradient>
    <linearGradient id="tasks_g-amber" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#FCD466" />
      <stop offset="1" stopColor="#EFA70F" />
    </linearGradient>
    <linearGradient id="tasks_g-green" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0" stopColor="#6DE4B5" />
      <stop offset="1" stopColor="#1FB983" />
    </linearGradient>
    <linearGradient id="tasks_tileDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#2B3138" />
      <stop offset="1" stopColor="#181C21" />
    </linearGradient>
  </defs>
  <rect width="48" height="48" rx="10.6" className="pq-tile-l" fill="url(#tasks_tile)" />
  <rect width="48" height="48" rx="10.6" className="pq-tile-d" fill="url(#tasks_tileDark)" />
  <rect x="0.5" y="0.5" width="47" height="47" rx="10.1" fill="none" stroke="var(--tile-stroke, rgba(15,23,42,0.10))" />
  <rect x="5" y="5" width="38" height="38" rx="7" fill="url(#tasks_g-green)" />
  <path d="M11.5 15.5l3.2 3.2 6-6.4" fill="none" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  <rect x="25" y="14" width="12" height="3" rx="1.5" fill="#FFFFFF" opacity="0.92" />
  <path d="M11.5 26.5l3.2 3.2 6-6.4" fill="none" stroke="url(#tasks_g-amber)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  <rect x="25" y="25" width="9" height="3" rx="1.5" fill="#FFFFFF" opacity="0.92" />
  <rect x="11.7" y="33" width="9" height="9" rx="2.6" fill="none" stroke="#FFFFFF" strokeWidth="2.6" opacity="0.75" />
  <rect x="25" y="36" width="12" height="3" rx="1.5" fill="#FFFFFF" opacity="0.55" />
</svg>
);

export const UtilityBell = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <g transform="translate(0 -4.35)">
    <path d="M16 31v-8a8 8 0 0 1 16 0v8l2.6 4.2a1 1 0 0 1-.85 1.5H14.25a1 1 0 0 1-.85-1.5z" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinejoin="round" />
    <path d="M20 37.5a4.2 4.2 0 0 0 8 0" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
  </g>
</svg>
);

export const UtilityMoon = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <path d="M30.5 9.5a15 15 0 1 0 8.5 21.8A16 16 0 0 1 30.5 9.5z" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
</svg>
);

export const UtilityPlus = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <rect x="7" y="7" width="34" height="34" rx="10" fill="none" stroke="currentColor" strokeWidth="2.2" opacity="0.4" />
  <path d="M24 15v18M15 24h18" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
</svg>
);

export const UtilitySearch = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <circle cx="21" cy="21" r="11" fill="none" stroke="currentColor" strokeWidth="2.8" />
  <path d="M29.5 29.5L39 39" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" />
</svg>
);

export const UtilitySun = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
  <circle cx="24" cy="24" r="8" fill="none" stroke="currentColor" strokeWidth="2.6" />
  <path d="M24 6v5M24 37v5M6 24h5M37 24h5M11.3 11.3l3.5 3.5M33.2 33.2l3.5 3.5M36.7 11.3l-3.5 3.5M14.8 33.2l-3.5 3.5" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
</svg>
);

/** Module tiles by asset stem (module-<stem>.svg). */
export const DOCK_TILES: Record<string, React.ReactNode> = {
  'analytics': TileAnalytics,
  'communication': TileCommunication,
  'crm': TileCrm,
  'dashboard': TileDashboard,
  'finance': TileFinance,
  'hr': TileHr,
  'marketing': TileMarketing,
  'owner': TileOwner,
  'performance': TilePerformance,
  'procurement': TileProcurement,
  'settings': TileSettings,
  'support': TileSupport,
  'tasks': TileTasks,
};
